import { render, staticRenderFns } from "./ProdutoFormulario.vue?vue&type=template&id=349844ee&scoped=true"
import script from "./ProdutoFormulario.vue?vue&type=script&lang=js"
export * from "./ProdutoFormulario.vue?vue&type=script&lang=js"
import style0 from "./ProdutoFormulario.vue?vue&type=style&index=0&id=349844ee&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349844ee",
  null
  
)

export default component.exports